import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/mixcloud': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M424.4 219.7C416.1 134.7 344.1 68 256.9 68 184.7 68 120.7 114.5 97.7 182.1 43.2 190.1 1.1 236.9 1.1 293.7 1.1 356 51.8 406.6 114.3 406.6H403.9C456.3 406.6 498.9 364.3 498.9 311.9 498.9 266.8 466.8 228.9 424.4 219.7zM403.9 364.3H114.3C75.3 364.3 43.4 332.7 43.4 293.7S75.3 223.1 114.3 223.1C133.2 223.1 150.9 230.5 164.2 243.8 184.1 263.8 214.3 233.6 194.3 213.6 179.7 199.2 161.7 189.3 142.3 184.3 162.2 140 207.1 110.4 256.9 110.4 326.4 110.4 382.9 166.8 382.9 236.1 382.9 249.6 380.7 262.9 376.5 275.7 367.6 303.2 408.7 314.6 416.7 288.9 419.4 280.6 421.7 272.1 423 263.5 442.4 271 456.5 289.8 456.5 311.9 456.5 340.7 433 364.3 403.9 364.3zM639 311.9C639 356 626.3 398.3 601.9 434.6 597.8 440.7 591.1 444 584.2 444 567.9 444 557.1 425.2 566.7 411.1 586.1 381.7 596.6 347.4 596.6 311.9S586.1 242.2 566.7 213.1C551.1 190.3 586.1 165.8 601.9 189.5 626.3 225.5 639 267.9 639 311.9zM568.1 311.9C568.1 343.5 559 373.9 541.3 400.3 537.1 406.3 530.5 409.4 523.6 409.4 506.4 409.4 496.5 390.4 506.1 376.4 519.1 357.3 525.8 335.2 525.8 311.9 525.8 288.9 519.1 266.5 506.1 247.4 490.3 224.4 525.1 200.3 541.3 223.9 559 249.9 568.1 280.4 568.1 311.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/mixcloud.js
// module id = x4cs
// module chunks = 144